module.exports = __webpack_public_path__ + "static/media/mem8YaGs126MiZpBA-UFWp0bbck.c080b58a.woff2";